export default "__VITE_ASSET__DgAVBMnH__"